import { render, staticRenderFns } from "./PaymentTransferModal.vue?vue&type=template&id=56313130&"
import script from "./PaymentTransferModal.vue?vue&type=script&lang=js&"
export * from "./PaymentTransferModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports